import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect, withRouter } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';

// Redux
import { connect } from 'react-redux';
import { setSuccess, clearErrors, setAlert } from '../../../../redux/actions/alertActions';

// API
import { getBuilding } from '../../../../api';

// Components
import BuildingForm from '../../../../components/BuildingForm';
import PageHeader from '../../../../components/PageHeader';

class Building extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirectToBuildings: false,
      building: null,
      isLoading: false
    };
  }

  componentDidMount() {
    const buildingID = this.props.match?.params?.id;

    this.setState({ isLoading: true });
    getBuilding(buildingID).then(building => {
      this.setState({ building: building, isLoading: false });
    }).catch(error => {
      this.setState({ isLoading: false });
      this.props.setError(error ? error : 'Error: Unable to retrieve building.');
    });
  }

  render() {
    return this.state.redirectToBuildings || !this.props.setupMode ? <Redirect to='/admin/buildings' /> : (
      <>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginBottom: '10px' }}>
          <PageHeader title='Update Building' />
          {this.state.isLoading && <CircularProgress style={{ color: this.props.statusColor.main }} />}
        </div>

        {this.state.building != null &&
        <BuildingForm onSuccess={() => this.setState({ redirectToBuildings: true })} building={this.state.building} />}
      </>
    );
  }
}

const mapStateToProps = state => ({
  statusColor: state.status.schoolStatus.getColor(),
  setupMode: state.setupMode.mode || state.setupMode.isLoading
});

const mapDispatchToProps = dispatch => ({
  setError: (msg) => setAlert(dispatch, msg),
  setSuccess: (msg) => setSuccess(dispatch, msg),
  clearErrors: () => dispatch(clearErrors())
});

Building.propTypes = {
  setError: PropTypes.func,
  setSuccess: PropTypes.func,
  clearErrors: PropTypes.func,
  match: PropTypes.object.isRequired,
  statusColor: PropTypes.object.isRequired,
  setupMode: PropTypes.bool.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Building));
